import { render, staticRenderFns } from "./zakazy_payed.vue?vue&type=template&id=3b8f8a7e&scoped=true&"
import script from "./zakazy_payed.vue?vue&type=script&lang=js&"
export * from "./zakazy_payed.vue?vue&type=script&lang=js&"
import style0 from "./zakazy_payed.vue?vue&type=style&index=0&id=3b8f8a7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f8a7e",
  null
  
)

export default component.exports